<template>
  <div id="home" class="main">
    <!-- 头部 -->
    <Header index="5"></Header>
    <div class="content">
       <!--[if lte IE 9]>
            <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="https://browsehappy.com/">upgrade your browser</a> to improve your experience and security.</p>
        <![endif]-->

        <!-- Add your site or application content here -->  

        <!-- prealoder area start -->
        <!-- <div id="loading">
            <div id="loading-center">
                <div id="loading-center-absolute">
                <div class="object" id="first_object"></div>
                <div class="object" id="second_object"></div>
                <div class="object" id="third_object"></div>
                </div>
            </div>      
        </div> -->
        <!-- prealoder area end -->

     
        <div class="body-overlay transition-3"></div>
        <!-- extra info area end -->

        <main>
           
            <!-- slider area end -->

            <!-- page title area start -->
            <section class="page__title p-relative d-flex align-items-center"  :style="'background-image:url(' + allurl + banner + ')'">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="page__title-inner text-center">
                                <h1>Contact Us</h1>
                                <div class="page__title-breadcrumb">                                 
                                    <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb justify-content-center">
                                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                        <li class="breadcrumb-item active" aria-current="page"> Contact</li>
                                    </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- page title area end -->

           <!-- contact area start -->
           <section class="contact__area pb-100 pt-95">
                <div class="container">
                    <div class="row" style="text-align: left;">
                        <div class="col-xl-6 col-lg-6">
                            <div class="contact__info">
                                <h3>Find us here.</h3>
                               <ul class="mb-55 text-left" >
                                    <li class="d-flex mb-35">
                                        <div class="contact__info-icon mr-20">
                                            <i class="fa fa-map-marker"></i>
                                        </div>
                                        <div class="contact__info-content">
                                            <h6>Address:</h6> 
                                            <span>{{addressinfo.title}}</span>
                                        </div>
                                    </li>
                                    <li class="d-flex mb-35">
                                        <div class="contact__info-icon mr-20">
                                            <i class="fa fa-envelope-open-o"></i>
                                        </div>
                                        <div class="contact__info-content">
                                            <h6>Email:</h6>
                                            <span>{{addressinfo.email}}</span>
                                        </div>
                                    </li>
                                    <li class="d-flex mb-35">
                                        <div class="contact__info-icon mr-20">
                                            <i class="fa fa-phone"></i>
                                        </div>
                                        <div class="contact__info-content">
                                            <h6>Number Phone:</h6>
                                            <span>{{addressinfo.phone}}</span>
                                        </div>
                                    </li>
                                </ul>
                                <p v-html="addressinfo.content"></p>

                                <div class="contact__social">
                                    <ul>
                                        <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
                                        <li><a href="https://www.facebook.com/runhillAU" target="_blank"><i class="fa fa-facebook-f"></i></a></li>
                                        <!-- <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i class="fa fa-behance"></i></a></li>
                                        <li><a href="#"><i class="fa fa-share-alt"></i></a></li> -->
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div class="contact__form">
                                <h3>Contact Us.</h3>
                                <div v-html="addressinfo.content"></div>
                                <!-- <div>Wholesale Inquiry Form</div>
                                <br/>
                                <div>Thank you so much for your interest in our products!</div>
                                <br/>
                                 <span>  We are always happy to accept new wholesale applications, and to make it easier for us to help you, we ask that you please fill in the following form. Once received and reviewed, we will do our best to reach back out to you in 2 weeks time.</span>
                                 -->
                               
                                <div style="margin: 20px;"></div>
                                    <el-form  label-position="top" :rules="rules" ref="formLabelAlign" label-width="80px" :model="formLabelAlign">
                                      <el-form-item label="Name" required prop="name">
                                        <el-input v-model="formLabelAlign.name" ></el-input>
                                        
                                      </el-form-item>
                                      <el-form-item label="Email" required prop="email">
                                          <el-input v-model="formLabelAlign.email" ></el-input>
                                      </el-form-item>
                                      
                                      <el-form-item label="Subject" required prop="subject">
                                        <el-input v-model="formLabelAlign.subject"></el-input>
                                      </el-form-item>
                                      <el-form-item label="Message" prop="message">
                                        <el-input type="textarea" v-model="formLabelAlign.message"></el-input>
                                      </el-form-item>
                                      <el-form-item>
                                        <el-button type="primary" @click="submitForm('formLabelAlign')">Create Now</el-button>
                                        <!-- <el-button @click="resetForm('formLabelAlign')">重置</el-button> -->
                                      </el-form-item>
                                    </el-form>
                                    <p class="ajax-response"></p>
                                </div>
                        </div>
                    </div>
                </div>
            </section>
             <!-- subscribe area start -->
                
                <!-- subscribe area end -->
            <!-- contact area end -->

             <!-- page title area start -->
           
            <!-- page title area end -->

            <!-- shop area start -->
           
            <!-- shop area end -->
            <!-- banner area start -->
           
            <!-- banner area end -->

            <!-- sale off area start -->
            
            <!-- sale off area end -->

            <!-- client slider area start -->
            
            <!-- client slider area end -->
         
            <!-- blog area start -->
            
            <!-- blog area end -->
 
            <!-- subscribe area start -->
            
            <!-- subscribe area end -->

            <!-- shop modal start -->
            <!-- Modal -->
            
                   
            <!-- shop modal end -->
        </main>

        
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../components/footer.vue";
import Header from "../../components/header.vue";
import { getmessages,getconcact } from "@/api/index/index";
export default {
  components: { Header, Footer },
  name: "home",
  data() {
    return {
      currentIndex: "",
      teacherIndex: '',
      ishove:true,
      menuctive:10,
      activeBtn: 2,
      clickIndex: 0,
      banner:'',
      lanmuhe:'',
      addressinfo:'',
    //   <span>New product &nbsp;|&nbsp; </span>
    //                                         <span>Discount |&nbsp; </span>
    //                                         <span>Rxpenditures </span>
      menuchoose:['New product','Discount','Expenditures'],
     formLabelAlign: {
          name: '',
          email: '',
          subject: '',
          message:''
        },
        formmessage: {
          name: '',
          email: '',
          phone: '',
        //   message:''
        },
        rules: {
            name: [
            { required: true, message: "请输入姓名", trigger: "blur" },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            email: [
                {
                    required: true,
                    message: "电子信箱不能为空",
                    trigger: "blur",
                },
                {
                    validator: function (rule, value, callback) {
                    if (
                        /^\w{1,64}@[a-z0-9\-]{1,256}(\.[a-z]{2,6}){1,2}$/i.test(
                        value
                        ) == false
                    ) {
                        callback(new Error("邮箱格式错误"));
                    } else {
                        callback();
                    }
                    },
                    trigger: "blur",
                },
            ],
           
            subject: [
                {
                    required: true,
                    message: "请输入subject",
                    trigger: "blur",
                }
            ]
        },
        ruless: {
            name: [
            { required: true, message: "请输入姓名", trigger: "blur" },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            email: [
                {
                    required: true,
                    message: "电子信箱不能为空",
                    trigger: "blur",
                },
                {
                    validator: function (rule, value, callback) {
                    if (
                       /^[a-zA-Z0-9]+([-_.][A-Za-z0-9]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/i.test(
                        value
                        ) == false
                    ) {
                        callback(new Error("邮箱格式错误"));
                    } else {
                        callback();
                    }
                    },
                    trigger: "blur",
                },
            ],
           
            phone: [
                {
                    required: true,
                    message: "请输入手机号",
                    trigger: "blur",
                }
            ]
        },
      value:'',
      leftIcon: require("../../assets/left.png"),
      rightIcon: require("../../assets/right-active.png"),

    };

  },
  mounted () {
    // let video = document.getElementsByClassName('video')
    // video.play()
    // 滚动条的获取
    this.getinfo()   
   
 
  },
  created(){
    //   console.log('滚动高度', window.pageYOffset)  
  },
  methods: {
    getinfo(){
        getconcact().then((res)=>{
            this.addressinfo=res.content
            this.banner=res.banner[0].image
        })    
    },
    
    addchoose(code){
        this.menuctive = code;
    },
    submitForm(formName){
      console.log(this.formLabelAlign)
      var form={}
      form.title=this.formLabelAlign.name
      form.ex_title=this.formLabelAlign.subject
      form.email=this.formLabelAlign.email
      form.content=this.formLabelAlign.message
      console.log(form)
       this.$refs[formName].validate((valid) => {
        if (valid) {
            getmessages(form).then((response) => {
               if (response.code == 200) {
                this.centerDialogVisible = false;
                this.msgSuccess("留言成功");
               
              } else {
                this.msgError("留言失败");
                
              } 
             })
        }
       })
      
    },
    submitForms(formName){
             
            // console.log(this.formmessage)
            var form={}
            form.title=this.formmessage.name
            form.phone=this.formmessage.phone
            form.email=this.formmessage.email
            // form.content=this.formmessage.message
            console.log(form)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // return
                    getmessages(form).then((response) => {
                    if (response.code == 200) {
                        this.centerDialogVisible = false;
                        this.msgSuccess(response.msg);
                    
                    } else {
                        this.msgError(response.msg);
                        
                    } 
                    })
                }
            })
            
            },
    changestyle(index) {
      this.currentIndex = index;
    },
    viewnews(id) {
            // this.$router.push({ name: "newsview" });
            this.$router.push({ name: "productview", query: { id } });
    },
    originstyle() {
      this.currentIndex = "";
    },
    clicktap(index) {
      this.clickIndex = index;
    },
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next();
        console.log(val)
        this.activeBtn = 2;
        this.rightIcon = require("../../assets/right-active.png");
        this.leftIcon = require("../../assets/left.png");
      } else {
        this.$refs.cardShow.prev();
        console.log(val)
        this.activeBtn = 1;
        this.leftIcon = require("../../assets/left-active.png");
        this.rightIcon = require("../../assets/right.png");
      }
    },
    changehandle (currentIndex,originIndex) {
      console.log(currentIndex,originIndex)
    },
    // 移入事件
    delHandleMouseEnter(index) {
        this.teacherIndex = index
    },
    // 移出
    delHandleMouseleave(){ 
        this.teacherIndex = ''
    }
  }
};
</script>

<style scoped lang='less'>
    .banner__area{z-index: 100;}
    .owl-carousel{display: flex;    flex-wrap: wrap;}
    .product__area .product__thumb a{display: block;}
    .col-xl-20{width:20%}
    // .col-lg-20{width:20%}
     .col-md-20{width:20%}
     .col-xs-6{width:50%}
    @media (min-width: 768px){
         .col-md-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
        }
       
    }
    @media (min-width: 990px){
         .col-md-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
        }
        .col-lg-20{-ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;}
       .col-xl-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
         }
    }

 

        //  .col-xl-20
    .sale__item a{display: block;}
    .banner__item{padding:10px;width:100%;background:#ccc;text-align: left;}
    .link-btn{border:2px solid #bc8246;border-radius: 10px;padding:1px 2px;text-transform: none;}
    .show-text span{cursor: pointer;}
    .show-text b{padding:1px 3px;}
    .el-button--primary{color: #ffffff;
    background-color: #323232;
    border-color: #323232;}
    .show-text .active b{background:#bc8246;border-radius: 10px;color:#fff}
    .subscribe__form .el-input{border:1px solid #c1c1c1!important;margin-bottom:0!important}
    // .shop__header-right{width:100%}
    // .mt--95{margin-top: -150px;}
    // @import "../../assets/css/preloader.css";
    // @import "../../assets/css/bootstrap.min.css";
    // @import "../../assets/css/slick.css";
    // @import "../../assets/css/owl.carousel.min.css";
    // @import "../../assets/css/animate.min.css";
    // @import "../../assets/css/jquery.fancybox.min.css";
    // // @import "../../assets/css/fontAwesome5Pro.css";
    // // @import "../../assets/css/ionicons.min.css";
    // @import "../../assets/css/default.css";
    // @import "../../assets/css/style.css";
    // <link rel="stylesheet" href="../../assets/css/preloader.css">
        // <link rel="stylesheet" href="../../assets/css/bootstrap.min.css">
        // <link rel="stylesheet" href="../../assets/css/slick.css">
        // <link rel="stylesheet" href="../../assets/css/metisMenu.css">
        // <link rel="stylesheet" href="../../assets/css/owl.carousel.min.css">
        // <link rel="stylesheet" href="../../assets/css/animate.min.css">
        // <link rel="stylesheet" href="../../assets/css/jquery.fancybox.min.css">
        // <link rel="stylesheet" href="../../assets/css/fontAwesome5Pro.css">
        // <link rel="stylesheet" href="../../assets/css/ionicons.min.css">
        // <link rel="stylesheet" href="../../assets/css/default.css">
        // <link rel="stylesheet" href="../../assets/css/style.css">
</style>



// WEBPACK FOOTER //
// src/views/team/team.vue